export default {
    path : "factory-item-focus",
    name : "factory-item-focus",
    meta : {
        title : "关注项目"
    },
    component: () => import('@/pages/factory/focus/Index'),
    redirect: {
        name : "factory-item-focus-whole"
    },
    children: [
        {
            path: 'all',
            name: 'factory-item-focus-whole',
            meta: {
                title: '厂房项目-列表页'
            },
            component: () => import('@/pages/itemCommon/List'),
        },
        {
            path: 'recent',
            name: 'factory-item-focus-recent',
            meta: {
                title: '厂房项目-列表页'
            },
            component: () => import('@/pages/itemCommon/List'),
        },
        {
            path: 'atme',
            name: 'factory-item-focus-atme',
            meta: {
                title: '厂房项目-列表页'
            },
            component: () => import('@/pages/itemCommon/List'),
        },
        {
            path: 'meat',
            name: 'factory-item-focus-meat',
            meta: {
                title: '厂房项目-列表页'
            },
            component: () => import('@/pages/itemCommon/List'),
        },
        {
            path: 'reply',
            name: 'factory-item-focus-reply',
            meta: {
                title: '厂房项目-列表页'
            },
            component: () => import('@/pages/itemCommon/List'),
        },
        {
            path: 'search',
            name: 'factory-item-focus-search',
            meta: {
                title: '厂房项目-列表页'
            },
            component: () => import('@/pages/itemCommon/List'),
        },
        {
            path: 'update',
            name: 'factory-item-focus-update',
            meta: {
                title: '厂房项目-列表页'
            },
            component: () => import('@/pages/itemCommon/List'),
        },
    ]
}


// WEBPACK FOOTER //
// ./src/router/factory/focusitem/index.js